import React, { useState } from "react";
import shortid from "shortid";
import { set } from "dot-prop-immutable";
import { createTabPane, characterShortId } from "@whalecloud/page-builder-core/utils/elementUtils";
import { Table, Icon } from '@whalecloud/fdx';
import { getLocale } from '@utils/util';

characterShortId(shortid);
const uuid = () => shortid.generate();

const TabsSettingsTable = (props: any) => {
  const messages = getLocale();

  const { updateElement, element } = props;
  const { tabs = [] } = element.data.formItemSettings;
  const { elements } = element;

  const optionArr = tabs.map(item => {
    return {
      ...item,
      key: item.key || item.text
    }
  });

  const [dataSource, setDataSource] = useState(optionArr || []);
  const [editingKey, setEditingKey] = useState('');
  const [addRowState, setAddRowState] = useState(false);
  const columns = [
    {
      title: messages['PAGEBUIDER_SETTINGS_TEXT'],
      dataIndex: "text",
      width: '75%',
      editable: true,
      editRules: [{ required: true, message: `Please Input label!` }]
    },
    {
      title: messages['PAGEBUIDER_SETTINGS_OPERATION'],
      dataIndex: "edit",
      width: '25%',
      editable: true,
      render: (text, record) => <a onClick={() => { delRow(record.key) }}><Icon type="delete" /></a>,
      editContent: () => <Icon type="edit" />,
      saveContent: () => <Icon type="save" />,
      cancelContent: () => <Icon type="stop" />
    }
  ];
  const delRow = key => {
    const index = dataSource.findIndex(v => v.key === key);
    const newElements = elements.filter((v, i) => i !== index);
    const newData = dataSource.filter(item => item.key !== key);
    setDataSource(newData);
    hanldeEleUpdate(newData, newElements)
  }

  const addRow = () => {
    const id = uuid();
    const data = dataSource.concat({
      key: id,
      text: `Tab_${id}`,
    });
    elements.push(createTabPane());
    setDataSource(data);
    setEditingKey(id);
    setAddRowState(true);
  };

  const onSaveRowEdit = (record, newData) => {
    setDataSource(newData);
    setEditingKey('');
    hanldeEleUpdate(newData, [...elements]);
  }

  const onCancelRowEdit = () => {
    if (addRowState) {
      dataSource.pop()
      setDataSource([...dataSource]);
      hanldeEleUpdate([...dataSource], [...elements]);
    }
    setAddRowState(false);
  }

  const hanldeEleUpdate = (tabs, children) => {
    let newElement = set(element, 'data.formItemSettings.tabs', tabs);
    newElement = set(newElement, 'elements', children);
    updateElement({
      element: newElement,
    });

  }

  const footer = () => <a onClick={addRow}>{messages['PAGEBUIDER_SETTINGS_ADD_NEW_OPTION']}</a>;
  return (
    <div>
      <Table
        columns={columns}
        dataSource={dataSource}
        scroll={{ y: 180 }}
        editRow
        editingKey={editingKey}
        onSaveRowEdit={onSaveRowEdit}
        onCancelRowEdit={onCancelRowEdit}
        footer={footer}
        className="formbuild-setting-table"
      />
    </div>
  );
}

export default TabsSettingsTable;
